import { render, staticRenderFns } from "./IcoLoadingRing.vue?vue&type=template&id=b1cb7bfe"
import script from "./IcoLoadingRing.vue?vue&type=script&lang=js"
export * from "./IcoLoadingRing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports